import React, { Component, createRef } from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";

import { platformHandler } from "../platforms/PlatformHandler";
import { requestPostSail } from "../utils/requester";
import { setSelectedPPT } from "../App/actions";

class SelectPDF extends Component {
  state = {
    hasChildren: false,
    expanded: false,
    addedClasses: [],
    level: 1,
    childLevelUpdated: false,
  };

  componentDidMount() {
    if (this.props.file) {
      this.processFile(this.props.file);
    }
  }

  sendPreview = (bitmap, index) => {
    const scope = this;
    var newFile = new Blob([bitmap]);
    platformHandler
      .getFirebaseConnector()
      .uploadImage(
        platformHandler.getUser(),
        platformHandler.getPPTName(),
        index,
        newFile,
        function (userId, pptName, slideIndex, downloadURL) {
          var payloadUrl = {
            pptName,
            userId,
            slideIndex,
            data: downloadURL,
            md5: "",
            last: scope.state.page > scope.state.pages,
            isPDF: true,
          };

          scope.slides.push({
            idSlide: index,
            md5: "",
            note: "",
            url: downloadURL,
          });

          scope.setState({ page: scope.state.page + 1 });
          scope.renderPage();
        }
      );
  };

  saveData = () => {
    if (this.canvasElement == null) {
      let divCanvasContainer = document.getElementById(
        "canvasContainer_fw_to_export"
      );
      if (divCanvasContainer == undefined) return;

      for (var i = divCanvasContainer.children.length - 1; i >= 0; i--) {
        if (divCanvasContainer.children[i].localName == "canvas") {
          this.canvasElement = divCanvasContainer.children[i];
          window.canv = this.canvasElement;
          break;
        }
      }
    }

    try {
      let downloadURL = this.canvasElement.toDataURL("image/jpeg");
      downloadURL = downloadURL.substring(downloadURL.indexOf(",") + 1);

      var bitmap = new Buffer(downloadURL, "base64");
      this.sendPreview(bitmap, this.state.page);
    } catch (e) {
      console.log("hubo error en 2", e);
    }
  };

  processFile = (file) => {
    const reader = new FileReader();

    reader.onabort = () => console.log("file reading was aborted");
    reader.onerror = () => console.log("file reading has failed");
    reader.onload = () => {
      // Do whatever you want with the file contents
      const binaryStr = reader.result;
      var pdfjsLib = require("pdfjs-dist");
      console.log("process", process.env.PUBLIC_URL);

      pdfjsLib.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker");

      // Read the PDF file into a typed array so PDF.js can load it.
      var rawData = new Uint8Array(binaryStr);

      // Load the PDF file.
      pdfjsLib.getDocument(rawData).promise.then((pdfDocument) => {
        console.log("pdf", pdfDocument);
        this.pdfDocument = pdfDocument;
        platformHandler.setTotalSlides(pdfDocument.numPages);
        console.log("# PDF document loaded.");

        const { onProgress } = this.props;
        if (onProgress) {
          onProgress(true, false);
        }
        this.setState({
          completed: true,
          page: 1,
          pages: pdfDocument.numPages,
        });

        this.slides = [];

        this.renderPage();
      });
    };
    reader.readAsArrayBuffer(file);
  };

  onDrop = (acceptedFiles) => {
    const { onProgress } = this.props;
    if (onProgress) {
      onProgress(true, false);
    }
    acceptedFiles.forEach((file) => {
      this.props.dispatch(setSelectedPPT(file.name, true));
      this.processFile(file);
    });
  };

  createInitialPayload = (numPages) => {
    let payloadMd5Data = {};
    payloadMd5Data.data = new Array(numPages);

    payloadMd5Data.pptName = platformHandler.getPPTName();
    payloadMd5Data.userId = platformHandler.getUser();
    payloadMd5Data.firstData = true;

    for (let index = 0; index < numPages; index++) {
      payloadMd5Data.data[index] = {
        idSlide: index + 1,
        md5: "",
        note: "",
        url: "",
      };
    }
    return payloadMd5Data;
  };

  sendPPTCompleted = () => {
    var payload = {
      pptName: platformHandler.getPPTName(),
      userId: platformHandler.getUser(),
      data: this.slides,
    };
    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "slides/updatePDF",
      payload,
      (data) => {
        if (data.success) {
          if (this.props.onFinished) {
            this.props.onFinished(payload.pptName, data.idSlides, data);
          } else {
            platformHandler.initEditor(payload.pptName, data.idSlides);
          }
        } else {
          // this.cbStateUpload( { error:true} ,isWin);
        }
      }
    );
  };

  renderPage = () => {
    // Get the first page.
    console.log("pide la " + this.state.page);
    if (this.state.page > this.state.pages) {
      this.sendPPTCompleted();
    } else {
      platformHandler.setStateInitPresentation(1, this.state.page);
      const { onProgress } = this.props;
      if (onProgress) {
        onProgress(false, true);
      }

      const { canvas } = this;
      this.pdfDocument.getPage(this.state.page).then((page) => {
        // Render the page on a Node canvas with 100% scale.
        var viewport = page.getViewport({ scale: 1.0 });

        const canvasContext = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
          canvasContext,
          viewport,
        };
        page.render(renderContext).promise.then(() => {
          this.saveData();
        });
      });
    }
  };

  render() {
    const { classes, hideComponent } = this.props;

    return (
      <div className={classes.divSelectPDF}>
        {! hideComponent && (
          <Dropzone
            multiple={false}
            ref={this.dropzoneRef}
            onDrop={this.onDrop}
          >
            {({ getRootProps, getInputProps }) => (
              <section>
                <div className={classes.baseStyle} {...getRootProps()}>
                  <input {...getInputProps()} accept=".pdf" />
                  <p>Arrastra un archivo PDF para crear una nueva presentación o haz click acá para seleccionarlo</p>
                </div>
              </section>
            )}
          </Dropzone>
        )}
        <div
          id="canvasContainer_fw_to_export"
          // style={{ position: "fixed", zIndez: "0" }}
          style={{ position: "fixed", visibility: "hidden", zIndez: "0" }}
        >
          <canvas
            ref={(canvas) => {
              this.canvas = canvas;
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(SelectPDF);



// WEBPACK FOOTER //
// ./src/containers/components/SelectPDF.js